const devProperties = {
  profile: "dev",
  apiBaseUrl: "https://dev.massbusinesszone.com",
  msil: {
    // CRITICAL SECURITY FIX: clientId is OK to expose (OAuth client IDs are public)
    clientId: "5miscbmfvmhp49mmdlekvumsst",
    redirectUrl: "https://dev.massbusinesszone.com/AdminHome/dashboard",
    federatedLoginUrl: "https://dev.massbusinesszone.com/api/auth/federated-login",
    exchangeUrl: "https://dev.massbusinesszone.com/api/auth/exchange-token",
    sessionUrl: "https://dev.massbusinesszone.com/api/auth/session",
    revenueUrl: "https://dev.massbusinesszone.com/api/v1/admin/revenue",
    // CRITICAL SECURITY FIX: Removed apiKey - now handled securely by backend
    // Backend endpoint: /api/auth/logout-federation
    // apiKey is stored in backend application.properties and never exposed to frontend
  },
};

export default devProperties;

